import { Message } from "../../components/ai/ai.types";
import { AxiosStatic } from "axios";
import { JwtTokenFn } from "@me8eon/authentication";

export type JqlOpenAiClient = (prompt: Message[]) => Promise<Message[]>

export type OpenAiConfigForJql = {
    axios: AxiosStatic,
    baseURL?: string
    jwtTokenFn: JwtTokenFn
    //Any customisation for the call. See https://platform.openai.com/docs/api-reference/chat/create
    customisation: any
    debug?: boolean
}
export const openAiClientForJql = (config: OpenAiConfigForJql): JqlOpenAiClient => {
    const { axios, baseURL, jwtTokenFn, customisation, debug } = config;
    if (!baseURL) throw new Error("baseURL is required for open ai. Have you set up the .env file?");
    return async (messages: Message[]): Promise<Message[]> => {
        if (debug) console.log("openAiMessagesClient", messages, config);

        const jwtToken = await jwtTokenFn();
        if (!jwtToken) return [];
        const axiosInstance = axios.create({
            baseURL,
            headers: {
                Authorization: `Bearer ${jwtToken}`,
                "Content-Type": "application/json",
            },
        });
        try {
            const response = await axiosInstance.post(`/service/completions`, {
                messages,
                ...customisation,
            });
            return response.data.choices.map((x: any) => x.message);
        } catch (error) {
            console.error("Error calling openai:", messages, error);
            throw error;
        }
    };
};
